// import React from "react";
// import { useFetchCustomerProfileQuery } from "../slices/customerProfileSlice";
// import { Link } from "react-router-dom";

// const ManageAccount = () => {
//   // Fetch customer profile data
//   const { data: profile, isLoading, error } = useFetchCustomerProfileQuery();

//   if (isLoading) {
//     return <p>Loading profile details...</p>;
//   }

//   if (error) {
//     return <p>Error fetching profile details: {error.message}</p>;
//   }

//   return (
//     <div className="container mx-auto p-6">
//       <h1 className="text-xl font-semibold mb-4">Manage Account</h1>

//       {/* Profile Details Section */}
//       <div className="bg-white shadow-sm rounded-md p-4 mb-6 border">
//         <h2 className="text-md font-medium mb-4">Profile Details</h2>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div>
//             <p className="text-sm font-semibold text-gray-500">First Name</p>
//             <p className="text-md">{profile.firstName || "N/A"}</p>
//           </div>
//           <div>
//             <p className="text-sm font-semibold text-gray-500">Last Name</p>
//             <p className="text-md">{profile.lastName || "N/A"}</p>
//           </div>
//           <div>
//             <p className="text-sm font-semibold text-gray-500">Phone Number</p>
//             <p className="text-md">{profile.phoneNumber || "N/A"}</p>
//           </div>
//         </div>
//         <div className="mt-4">
//           <p className="text-sm font-semibold text-gray-500">Email</p>
//           <p className="text-md">{profile.email || "N/A"}</p>
//         </div>
//       </div>

//       {/* Password Security Section */}
//       <div className="bg-white shadow-sm rounded-md p-4 border">
//         <h2 className="text-md font-medium mb-4">Password Security</h2>
//         <p className="text-sm text-gray-500 mb-2">
//           Change your password at any time
//         </p>
//         <div className="flex justify-between items-center">
//           <Link
//             to="/change-password"
//             className="text-agBlue hover:underline text-sm font-medium cursor-pointer"
//           >
//             Change password &rarr;
//           </Link>
//           <button className="text-agRed hover:underline text-sm font-medium cursor-pointer">
//             Close Account
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ManageAccount;

import React, { useState } from "react";
import { useFetchCustomerProfileQuery } from "../slices/customerProfileSlice";
import {
  useChangePasswordMutation,
  useDeactivateAccountMutation,
} from "../slices/authSlice";
import PasswordInput from "../components/utilComponents/PasswordInput";
import Button from "../components/utilComponents/Button";
import Modal from "../components/layout/Modal";

const ManageAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [deactivateAccount, { isLoading: isDeactivating }] =
    useDeactivateAccountMutation();

  // Fetch customer profile data
  const { data: profile, isLoading, error } = useFetchCustomerProfileQuery();
  const [changePassword, { isLoading: isChangingPassword }] =
    useChangePasswordMutation();

  //   const handlePasswordReset = () => {
  //     if (newPassword !== confirmNewPassword) {
  //       setErrorMessage("Passwords do not match!");
  //       return;
  //     }

  //     // Implement your password reset logic here (e.g., API call)
  //     console.log("Password reset submitted", {
  //       currentPassword,
  //       newPassword,
  //     });

  //     setIsModalOpen(false);
  //   };

  const handleDeactivateAccount = async () => {
    if (!window.confirm("Are you sure you want to deactivate your account?"))
      return;

    try {
      await deactivateAccount().unwrap();
      setSuccessMessage("Account deactivated successfully!");
    } catch (error) {
      setErrorMessage(
        error?.data?.message || "Failed to deactivate account. Try again.",
      );
    }
  };

  const handlePasswordReset = async () => {
    if (newPassword !== confirmNewPassword) {
      setErrorMessage("Passwords do not match!");
      return;
    }

    try {
      await changePassword({
        oldPassword: currentPassword,
        newPassword,
      }).unwrap();

      setSuccessMessage("Password changed successfully!");
      setIsModalOpen(false);
    } catch (error) {
      setErrorMessage(
        error?.data?.message || "Failed to change password. Try again.",
      );
    }
  };

  if (isLoading) {
    return <p>Loading profile details...</p>;
  }

  if (error) {
    return <p>Error fetching profile details: {error.message}</p>;
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-xl font-semibold mb-4">Manage Account</h1>

      {/* Profile Details Section */}
      <div className="bg-white shadow-sm rounded-md p-4 mb-6 border">
        <h2 className="text-md font-medium mb-4">Profile Details</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm font-semibold text-gray-500">First Name</p>
            <p className="text-md">{profile.firstName || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-500">Last Name</p>
            <p className="text-md">{profile.lastName || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-500">Phone Number</p>
            <p className="text-md">{profile.phone || "N/A"}</p>
          </div>
        </div>
        <div className="mt-4">
          <p className="text-sm font-semibold text-gray-500">Email</p>
          <p className="text-md">{profile.email || "N/A"}</p>
        </div>
      </div>

      {/* Password Security Section */}
      <div className="bg-white shadow-sm rounded-md p-4 border">
        <h2 className="text-md font-medium mb-4">Password Security</h2>
        <p className="text-sm text-gray-500 mb-2">
          Change your password at any time
        </p>
        <div className="flex justify-between items-center">
          <button
            onClick={() => setIsModalOpen(true)}
            className="text-blue-600 hover:underline text-sm font-medium"
          >
            Change password &rarr;
          </button>
          {/* <button className="text-red-600 hover:underline text-sm font-medium">
            Close Account
          </button> */}
          <button
            onClick={handleDeactivateAccount}
            className="text-red-600 hover:underline text-sm font-medium"
            disabled={isDeactivating}
          >
            {isDeactivating ? "Deactivating..." : "Close Account"}
          </button>
        </div>
      </div>

      {/* Password Reset Modal */}
      <Modal isVisible={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="p-4">
          <h2 className="text-lg font-medium mb-4">Password Reset</h2>
          {errorMessage && (
            <p className="text-red-500 text-sm mb-4">{errorMessage}</p>
          )}
          <div className="mb-4">
            <label
              htmlFor="currentPassword"
              className="block text-sm font-medium text-gray-700"
            >
              Current password
            </label>
            <PasswordInput
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              isFullWidth
              showConditions={false}
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="newPassword"
              className="block text-sm font-medium text-gray-700"
            >
              New password
            </label>
            <PasswordInput
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              isFullWidth
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="confirmNewPassword"
              className="block text-sm font-medium text-gray-700"
            >
              Re-enter new password
            </label>
            <PasswordInput
              id="confirmNewPassword"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              isFullWidth
              showConditions={false}
            />
          </div>
          <Button onClick={handlePasswordReset}>Change Password</Button>
        </div>
      </Modal>
    </div>
  );
};

export default ManageAccount;
